import type { ComponentType } from "svelte";
import type { IconType } from "$components/+blocks/OVIcon/OVIcon";

export enum SidePanelState {
  Collapsed = "collapsed",
  Expanded = "expanded",
}

export enum ForumDensity {
  Collapsed = "collapsed",
  Expanded = "expanded",
  Gallery = "gallery",
}

export enum ForumView {
  Compact = "compact",
  Full = "full",
  Default = "default",
}

export interface SelectOption {
  id: number | string;
  name: string;
  value: string | boolean | null;
  description?: string;
  disabled?: boolean;
  icon?: IconType;
  iconColor?: string;
}

export interface SvelteRadioOption extends Omit<SelectOption, "id" | "description"> {
  description?: string;
  icon?: IconType;
  innerComponent?: ComponentType;
}

export enum Theme {
  Light = "light",
  Dark = "dark",
}

export type ThemeDetails = {
  label: string;
  color: string;
  scrollbarColor: string;
};

export interface AvatarDetails {
  uuid: string;
  profileColor?: string;
  profileImage: string;
  handle?: string;
}

export enum SessionFilter {
  Upcoming = "Upcoming",
  Previous = "Previous",
}

export enum ThreadFilter {
  All = "All",
  Solved = "Solved",
  Unsolved = "Unsolved",
  Unread = "Unread",
}

export type SpaceType = "forum" | "custom" | "video";
